export default __webpack_public_path__ + "img/cc-800.b19133ec.jpg";